// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1_7RI","tab":"Tabs_tab__3eWJQ","tabActive":"Tabs_tabActive__2FzBj"};